export const ADDRESS_DEBOUNCE_TIME = 150
export const INDUSTRY_DEBOUNCE_TIME = 250

export const MIGRATION = 'migration'
export const MAJOR_ACCOUNT_CHANGE = 'major_account_change'
export const NEW_APPLICATION = 'new'
export const CREDIT_APPLICATION = 'creditApplication'
export const ADVANCED_ONBOARDING = 'advancedOnboarding'

// Keys used in local storage
export const AUTH_STORAGE_TOKEN_KEY = 'logged_in_user_token'
export const APPLICANT_EMAIL_HASH_KEY = 'applicant_email_hash'
export const APPLICANT_EMAIL_KEY = 'applicant_email_key'
export const APPLICANT_AUTH_ID = 'applicant_auth_id'
export const SALESFORCE_CREDIT_IDS = 'salesforce_credit_ids'
export const APPLICANT_DATA_FROM_UP = 'applicant_data_from_up'
export const LT_LANDING_PAGE = 'lt_landing_page'

export const LOCAL_STORAGE_KEYS = {
  APPLICANT_AUTH_ID,
  APPLICANT_EMAIL_KEY,
  APPLICANT_EMAIL_HASH_KEY,
  AUTH_STORAGE_TOKEN_KEY,
  SALESFORCE_CREDIT_IDS,
  APPLICANT_DATA_FROM_UP,
  LT_LANDING_PAGE,
}
export const BDC_MODAL_VIEWED_KEY = 'bdc_modal_viewed'

/* When using these, implement by destructuring the values inside the object */
/* example: const { BILL_SPEND_AND_EXPENSE, BILL_DIVVY_CARD, BILL_DIVVY_RESERVE_CARD, BILL, DIVVY_PAY_LLC } = PRODUCT_CONST_STRINGS */
export const PRODUCT_CONST_STRINGS = {
  BILL_SPEND_AND_EXPENSE: 'BILL Spend & Expense',
  BILL_DIVVY_RESERVE_CARD: 'Secured credit line', // this may continue to change.
  BILL_DIVVY_CARD: 'BILL Divvy Card',
  BILL: 'BILL',
  DIVVY_PAY_LLC: 'DIVVY PAY LLC',
}

export const PATHNAME_CONSTS = {
  // legacy (v2) routes
  AUTH_PATH: '/auth',
  MIGRATION_PATH: '/migration',
  VERIFY_EMAIL_PATH: '/verify-email',
  VERIFY_CODE_PATH: '/verify-code',
  MULTI_CREDIT_LINE_OFFER_PATH: '/credit-line-offers',
  MULTI_OFFER_TO_STANDARD_OFFER_PATH: '/credit-line-offers/standard-offer',
  MULTI_OFFER_TO_VARIABLE_OFFER_PATH: '/credit-line-offers/variable-offer',
  MULTI_OFFER_TO_SECURED_OFFER_PATH: '/credit-line-offers/secured-offer',
  SINGLE_CREDIT_LINE_OFFER_PATH: '/credit-line-offer',
  DUAL_OFFER_PATH: '/dual-offer',
  PRE_APPROVED_PATH: '/pre-approved',
  DECLINED_PATH: '/declined',
  SUBMISSION_ERROR_PATH: 'submission-error',
  STANDARD_OFFER_PATH: 'standard-offer',
  VARIABLE_OFFER_PATH: 'variable-offer',
  SECURED_OFFER_PATH: 'secured-offer',
  SUBMITTING_APPLICATION: 'submitting-application',
  REVIEWING_OFFER: 'reviewing-offer',
  ACCEPTING_OFFER: 'accepting-offer',
  REVIEW_AND_SIGN_PATH: 'review-and-sign',
  BUSINESS_INFO_PATH: 'business-info',
  MANUAL_REVIEW_PATH: 'working-out-details',

  // v3 app routes

  MOBILE_DOCUMENT_UPLOAD_PATH: '/mobile-document-upload',
  DASHBOARD_PATH: '/dashboard',
  /* pre application routes */
  AUTH_PATH_ABSOLUTE: 'auth',
  MIGRATION_PATH_ABSOLUTE: 'migration', // do we need for v3?
  BDC_LANDING_PATH: '/bdc-landing',
  VERIFY_PATH: 'verify',
  POST_LOGIN_PATH: 'login-success',
  GOOD_FIT_SURVEY_PATH: '/survey',
  GOOD_FIT_RESULT_PATH: 'good-fit',
  NOT_GOOD_FIT_RESULT_PATH: 'not-good-fit',
  GET_TO_KNOW_YOU: '/get-to-know',

  /* credit application form routes */
  NAME_AND_OWNERSHIP_PATH: 'name-and-ownership',
  BUSINESS_ADDRESS_PATH: 'business-address',
  FINANCIAL_DETAILS_PATH: 'financial-details',
  CONNECT_BANK_ACCOUNT_PATH: 'connect-bank-account',
  PEOPLE_INFO_PATH: 'people-info',
  REVIEW_PATH: 'review',

  /* after app submission routes */
  NO_OFFER_PATH: 'no-offer',
  OFFERS_PATH: 'offers',
  STANDARD_CREDIT_LINE_PATH: 'standard-credit-line',
  VARIABLE_CREDIT_LINE_PATH: 'variable-credit-line',
  PREPAY_OFFER_PATH: 'prepay',
  OFFER_ACCEPTED_PATH: 'accepted',
  FROZEN_CREDIT_PATH: 'frozen-credit',
  WORKING_OUT_DETAILS_PATH: 'working-out-details',
  MIGRATION_SUCCESS_PATH: 'success',
}

const baseWebAssetsPdfPath = 'https://app.divvy.co/assets/pdfs/bill_divvy_signup_application_'

export const URL = {
  APP_PROD: 'apply.divvy.co',
  BILL_PRIVACY_NOTICE: 'https://www.bill.com/privacy',
  BILL_REWARDS_LINK: 'http://bill.com/product/rewards',
  BILL_REWARDS_TERMS: 'https://www.bill.com/legal/bill-rewards-program',
  BILL_AP_AR: 'https://www.bill.com/product/accounts-payable',
  BILL_TERMS_AND_CONDITIONS: 'https://www.bill.com/legal/spend-expense-terms-of-service',
  CREDIT_IMPACT_LEARN_MORE: 'https://help.getdivvy.com/en/articles/5043115-divvy-credit-application-faq#h_8ce5a44308',
  ELIGIBILITY_REQUIREMENTS_LINK:
    'https://help.getdivvy.com/en/articles/6282738-what-are-the-eligibility-requirements-for-divvy-s-credit-application',
  DIVVY_PROD: 'https://app.divvy.co',
  DIVVY_PROD_PASSWORD_SETUP: 'https://app.divvy.co/setup/password',

  // DSA TERMS
  DSA_TERMS_WEX_BO: `${baseWebAssetsPdfPath}dsa_wex_bo.pdf`,
  DSA_TERMS_WEX_JS: `${baseWebAssetsPdfPath}dsa_wex_js.pdf`,
  DSA_TERMS_CRB_BO: `${baseWebAssetsPdfPath}dsa_crb_bo.pdf`,
  DSA_TERMS_CRB_JS: `${baseWebAssetsPdfPath}dsa_crb_js.pdf`,
  DSA_TERMS_WEBBANK_PG: `${baseWebAssetsPdfPath}dsa_web_bank_pg.pdf`,
  DSA_TERMS_WEBBANK_BO: `${baseWebAssetsPdfPath}dsa_web_bank_bo.pdf`,

  GOOGLE_TERMS_OF_SERVICE: 'https://policies.google.com/terms',
  GOOGLE_PRIVACY_POLICY: 'https://policies.google.com/privacy',
  STANDARD_LINE_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/000003577',
  VARIABLE_LINE_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/6702952',
  PREPAY_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/000003645',
  EXPERIAN_FREEZE_CENTER: 'https://www.experian.com/freeze/center.html',
  EXPERIAN_LEARN_MORE: 'http://help.getdivvy.com/en/articles/6156143',
  BILL_HELP_CENTER_LINK: 'https://help.bill.com/direct/s/',
  BILL_LEGAL_LINK: 'https://www.bill.com/legal/',
  BILL_SECURITY_LINK: 'https://www.bill.com/product/security',
}

/**
 ** @deprecated use CreditApplicationStatus from '_gql'
 **/
export const CreditApplicationStatus = {
  ACCOUNT_READY: 'ACCOUNT_READY',
  APPROVED: 'APPROVED',
  AWAITING_SIGNATURE: 'AWAITING_SIGNATURE',
  BUILD_ACCOUNT: 'BUILD_ACCOUNT',
  CLOSED_AS_DUPLICATE: 'CLOSED_AS_DUPLICATE',
  CLOSED_LOST: 'CLOSED_LOST',
  COMPANY_BUILT: 'COMPANY_BUILT',
  CORRECTION_REQUESTED: 'CORRECTION_REQUESTED',
  CUSTOMER_CANCELED: 'CUSTOMER_CANCELED',
  EXPIRED: 'EXPIRED',
  FROZEN_CREDIT: 'FROZEN_CREDIT',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  MORE_INFO_NEEDED: 'MORE_INFO_NEEDED',
  NOT_STARTED: 'NOT_STARTED',
  OFFER_ACCEPTED: 'OFFER_ACCEPTED',
  OFFER_DECLINED: 'OFFER_DECLINED',
  REJECTED: 'REJECTED',
  REVIEW_OFFER: 'REVIEW_OFFER',
  SUBMITTED: 'SUBMITTED',
  VALIDATION_IN_PROGRESS: 'VALIDATION_IN_PROGRESS',
  VALIDATION_IN_REVIEW: 'VALIDATION_IN_REVIEW',
  VALIDATION_NOT_STARTED: 'VALIDATION_NOT_STARTED',
  VALIDATION_SUCCESSFUL: 'VALIDATION_SUCCESSFUL',
  MIGRATION_COMPLETE: 'MIGRATION_COMPLETE',
}

export const EDITABLE_STATUSES = ['AWAITING_SIGNATURE', 'IN_PROGRESS', 'CORRECTION_REQUESTED', 'NOT_STARTED']

export const LEGAL_BUSINESS_NAME = 'LEGAL_BUSINESS_NAME'
export const TAX_ID = 'TAX_ID'
export const AUTHORIZED_SIGNER = 'AUTHORIZED_SIGNER'
export const BENEFICIAL_OWNER_0 = 'BENEFICIAL_OWNER_0'
export const BENEFICIAL_OWNER_1 = 'BENEFICIAL_OWNER_1'
export const BENEFICIAL_OWNER_2 = 'BENEFICIAL_OWNER_2'
export const BENEFICIAL_OWNER_3 = 'BENEFICIAL_OWNER_3'

export const PAGE_NAME_STRINGS = {
  PAGE_AUTHORIZED_SIGNER: 'authorizedSigner',
  PAGE_BUSINESS_INFO: 'businessInfo',
  PAGE_COMPANY_OWNERS: 'companyOwners',
  PAGE_BENEFICIAL_OWNERS: 'beneficialOwners',
  PAGE_FINANCE_INFO: 'financeInfo',
  PAGE_REVIEW_AND_SIGN: 'reviewAndSign',
  PAGE_REVIEW_AND_VALIDATE: 'reviewAndValidate',
  PAGE_MIGRATION_SUCCESS: 'migrationSuccess',
  PAGE_DIVVY_PROGRAM_FIT: 'divvyProgramFit',
  PAGE_DASHBOARD: 'dashboard',
  PAGE_APPLICATION_SUBMITTED: 'applicationSubmitted',
  PAGE_VERIFY_CODE: 'verifyCode',
  PAGE_STANDARD_OFFER: 'standardCreditLineOffer',
  PAGE_VARIABLE_OFFER: 'variableCreditLineOffer',
}
